import type { LucideIcon } from "lucide-react";
import { cn } from "./cn";

type IconSize = 16 | 20;

interface IconProps {
  icon: LucideIcon;
  /** Lucide only, 16 or 20 px, 1.5 px stroke (design-system §2). */
  size?: IconSize;
  /** Accessible name when the icon stands alone; omit when a visible label sits next to it. */
  label?: string;
  className?: string;
}

/** The one way to render an icon, so size, stroke and labelling never drift. */
export function Icon({ icon: Glyph, size = 16, label, className }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={1.5}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      className={cn("shrink-0", className)}
    />
  );
}
